module.exports = __webpack_public_path__ + "static/media/counselling1.49ef136d.png";